const PUBLIC_URL = process.env.PUBLIC_URL || '';

const marketingAsset = (path) => `${PUBLIC_URL}${path}`;

export const marketingLogos = {
  lockupDark: marketingAsset('/marketing/branding/vm-logo-lockup-dark.svg'),
  lockupLight: marketingAsset('/marketing/branding/vm-logo-lockup-light.svg'),
  compactDark: marketingAsset('/marketing/branding/vm-logo-compact-dark.svg'),
  compactLight: marketingAsset('/marketing/branding/vm-logo-compact-light.svg'),
};

export const marketingSymbols = {
  silhouette: marketingAsset('/marketing/branding/vm-symbol-silhouette.svg'),
};

export const marketingPalette = {
  heroBlue: '#31b6e4',
  heroBlueStrong: '#23a4d1',
  heroBlueSoft: '#d9f2fd',
  heroBlueMist: '#eef9ff',
  heroBlueCloud: '#f6fbff',
  heroBlueSurface: '#e8f5fd',
  heroBlueDeep: '#123d67',
  heroBlueDeeper: '#0d2d4e',
  heroBlueMid: '#1c6da1',
  ink: '#173b5b',
  inkSoft: '#5f7b96',
  white: '#f9fdff',
};

export const marketingNavigation = [
  { title: 'Home', path: '/' },
  { title: 'About', path: '/about' },
  { title: 'Downloads', path: '/downloads' },
];

export const patientSlides = [
  {
    src: marketingAsset('/marketing/patients/femaleasianadult.jpg'),
    alt: 'Adult Asian female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/maleblackadult.jpg'),
    alt: 'Adult Black male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/femalecaucasianyoung.jpg'),
    alt: 'Young Caucasian female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/malesouthasianadult.jpg'),
    alt: 'Adult South Asian male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/femaleblackyoung.jpg'),
    alt: 'Young Black female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/maleasianyoung.jpg'),
    alt: 'Young Asian male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/femalecaucasianelderly.jpg'),
    alt: 'Older Caucasian female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/malecaucasianadult.jpg'),
    alt: 'Adult Caucasian male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/femalesouthasianadult.jpg'),
    alt: 'Adult South Asian female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/maleblackyoung.jpg'),
    alt: 'Young Black male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/femaleasianyoung.jpg'),
    alt: 'Young Asian female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/malecaucasianelderly.jpg'),
    alt: 'Older Caucasian male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/femaleblackadult.jpg'),
    alt: 'Adult Black female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/maleasianadult.jpg'),
    alt: 'Adult Asian male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/femalecaucasianadult.jpg'),
    alt: 'Adult Caucasian female virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/malecaucasianyoung.jpg'),
    alt: 'Young Caucasian male virtual patient seated in a consultation room.',
  },
  {
    src: marketingAsset('/marketing/patients/malecaucasianadult2.jpg'),
    alt: 'Adult Caucasian male virtual patient seated in a consultation room.',
  },
];
